import type { FC } from "react";

export const Triangle: FC<{ className?: string; trendUp: boolean }> = ({ className, trendUp }) => {
    return (
        <svg
            className={className}
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d={trendUp ? "M5 0L10 10H0L5 0Z" : "M5 10L0 0H10L5 10Z"} fill="currentColor" />
        </svg>
    );
};
